module.exports = __webpack_public_path__ + "img/Plus-Icon.255dd72b.svg";